import { useEffect, useState } from "react";
import { AssetModel } from "../models/asset";
import { fetchAssetModels } from "../api/fetchAssets";

function useAssetModels() {
    const [assetModels, setAssetModels] = useState<AssetModel[]>([]);

    useEffect(() => {
        getAssetModels();
    }, []);

    const getAssetModels = async () => {
        const data = await fetchAssetModels();
        setAssetModels(data);
    }

    return { assetModels }
}

export default useAssetModels;